import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePipe, UpperCasePipe } from '@angular/common';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown/multiselect.model';
import { MatSelectChange } from '@angular/material/select';
@Component({
  selector: 'app-pms-system-unlock-popup',
  templateUrl: './pms-system-unlock-popup.component.html',
  styleUrls: ['./pms-system-unlock-popup.component.scss'],
})
export class PmsSystemUnlockPopupComponent implements OnInit {

  operation: any;
  selectedEmployee: any = [];
  selectedMonths: any = [];
  dropdownSettings: IDropdownSettings = {};
  numbersOfDaysArray = Array.from({ length: 30 }, (_, i) => i);
  selectedDay: any=null;
  relockDate: any;
  buttonColorName: any;
  loggedInUserCompanyID:any;
  addNewUnlockSystemCurrentYear:any;
  fromYear: any;
  toYear: any;
  getAllUsersList:any=[];
  getAllFutureMonthList:any=[];
  pmsUnlockStatusId:any=null;
  addSubmitForm:boolean=false;
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any,
    private httpService: HttpService,
    private config: Config,
    public dialogRef: MatDialogRef<PmsSystemUnlockPopupComponent>,
    private fb: FormBuilder,
    public sharedService: SharedService,
    private encryptionService: EncryptionService,
    private datePipe: DatePipe,
    private loader: LoaderService,
    public dialog: MatDialog,
    private upperCasePipe: UpperCasePipe) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.operation = this.dialogData.operation;
    this.pmsUnlockStatusId = this.dialogData.id
    this.addNewUnlockSystemCurrentYear = this.dialogData.addNewUnlockSystemCurrentYear;
    this.getAllUsersDropdownForTaskManagement();
    this.getFutureMonthsDropdown();
    if(this.operation == 'Edit'){
      this.getPMSUnloackStatus();
    }
  }
  selectAllEmployee(items: any): void {
    this.selectedEmployee = items;
  }
  onDeSelectAllEmployee() {
    this.selectedEmployee = [];
  }
  selectAllMonths(items: any): void {
    this.selectedMonths = items;
  }
  onDeSelectAllMonths() {
    this.selectedMonths = [];
  }
  chnageSelectedDay() {
    const date = new Date();
    this.relockDate = date.setDate(date.getDate() + Number(this.selectedDay)); // Add 1 day
  }
  addPmsUnlockStatus() {
    this.addSubmitForm = true;
    var test = this.addNewUnlockSystemCurrentYear?.split('-');
    if(this.selectedMonths.length!=0 && this.selectedEmployee.length!=0 && this.selectedDay!=null){
      this.addSubmitForm = false;
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "fromYear": test[0],
        "id": this.pmsUnlockStatusId,
        "month": this.selectedMonths.map((ele:any)=>ele.id),
        "relockDate": this.datePipe.transform(this.relockDate,'yyyy-MM-dd'),
        "relockDays": this.selectedDay,
        "toYear": test[1],
        "userId": this.selectedEmployee.map((ele:any)=>ele.id)
      }
      this.httpService.callPostService(this.config.addPmsUnlockStatus, request).subscribe((data: any) => {
        if(data?.status){
          this.dialogRef.close(false);
          const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            },
          });
          successdialogRef.afterClosed().subscribe(result => {
  
          });
        }
      })
    }
  }
  getAllUsersDropdownForTaskManagement(){
    var test = this.addNewUnlockSystemCurrentYear?.split('-');
    const date = new Date()
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "from": this.datePipe.transform(date,'yyyy-MM-dd'),
      "fromYear": test[0],
      "search": null,
      "to": this.datePipe.transform(date,'yyyy-MM-dd'),
      "toYear": test[1]
    }
    this.httpService.callPostService(this.config.getAllUsersDropdownForTaskManagement, request).subscribe((data: any) => {
      this.getAllUsersList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName,
        }
        this.getAllUsersList.push(obj);
      });
    })
  }
  getFutureMonthsDropdown(){
    var test = this.addNewUnlockSystemCurrentYear?.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "search": null,
      "toYear": test[1]
    }
    this.httpService.callPostService(this.config.getFutureMonthsDropdown, request).subscribe((data: any) => {
      this.getAllFutureMonthList = [];
      data?.data?.months?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: this.sharedService.transform(ele),
        }
        this.getAllFutureMonthList.push(obj);
      });
    })
  }
  getPMSUnloackStatus(){
    const request = {
      "id": this.pmsUnlockStatusId,
    }
    this.httpService.callPostService(this.config.getPmsUnlockById, request).subscribe((data: any) => {
      this.selectedMonths = [];
      this.selectedEmployee = [];
      data?.data?.month.forEach((ele:any)=>{
        let obj ={
          id: ele,
          name: this.sharedService.transform(ele)
        }
        this.selectedMonths.push(obj);
      })
      data?.data?.user.forEach((ele:any)=>{
        let obj ={
          id: ele.id,
          name: ele.firstName+' '+ele.lastName
        }
        this.selectedEmployee.push(obj);
      })
      this.selectedDay = data.data?.relockDays;
      this.chnageSelectedDay();
    })
  }
}
